
const Footer = () => {

  const year = new Date().getFullYear()

  return (
    <p className="text-center">
      <span>
          {year} © Бүх эрх хуулиар хамгаалагдсан Сургалтын удирдлагын систем - Туршилтын хувилбар
      </span>
  </p>
  )
}

export default Footer
